import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPitLimiter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.011 16.968",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.028.028a13.04 13.04 0 0 1 13.85 14.87c-.12.83-.22 1.99-1.26 2.07H1.388c-1.04-.09-1.14-1.25-1.26-2.07a13.06 13.06 0 0 1 11.9-14.87m-8.09 13.64c.36-.38.24-1.14.3-1.65a8.833 8.833 0 0 1 10.94-7.55c.5.12 1.01.45 1.5.27a.967.967 0 0 0 .38-1.54 5.7 5.7 0 0 0-2.19-.75 10.74 10.74 0 0 0-12.2 7.71 8.6 8.6 0 0 0-.32 3.17.96.96 0 0 0 1.58.33Zm15.77-8.5a.8.8 0 0 0-.38.18l-5.14 5.14c-.16.08-.46-.1-.66-.13a2.688 2.688 0 1 0 1.94 1.51l5.12-5.11a.953.953 0 0 0-.86-1.6Z" })
});
export default SvgPitLimiter;
